var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68128 8.80932C7.16393 8.78519 7.57475 9.15689 7.59888 9.63953L8.00388 17.7394C8.03381 18.3381 8.52799 18.8082 9.12747 18.8082H14.3225C14.922 18.8082 15.4161 18.3381 15.4461 17.7394L15.8511 9.63953C15.8752 9.15689 16.286 8.78519 16.7687 8.80932C17.2513 8.83345 17.623 9.24428 17.5989 9.72692L17.1939 17.8268C17.1174 19.3569 15.8545 20.5582 14.3225 20.5582H9.12747C7.59546 20.5582 6.33257 19.3569 6.25606 17.8268L5.85107 9.72692C5.82694 9.24428 6.19863 8.83345 6.68128 8.80932Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1 5.15002V5.89523H13.9152V5.15002H10.1ZM8.34998 4.97068C8.34998 4.10482 9.05477 3.40002 9.92063 3.40002H14.0945C14.9604 3.40002 15.6652 4.10482 15.6652 4.97068V6.77023C15.6652 7.25348 15.2734 7.64523 14.7902 7.64523H9.22498C8.74173 7.64523 8.34998 7.25348 8.34998 6.77023V4.97068Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34998 6.77014C4.34998 6.28689 4.74173 5.89514 5.22498 5.89514H18.725C19.2082 5.89514 19.6 6.28689 19.6 6.77014C19.6 7.25339 19.2082 7.64514 18.725 7.64514H5.22498C4.74173 7.64514 4.34998 7.25339 4.34998 6.77014Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.225 10.8083C10.7082 10.8083 11.1 11.2 11.1 11.6833V16.6833C11.1 17.1665 10.7082 17.5583 10.225 17.5583C9.74173 17.5583 9.34998 17.1665 9.34998 16.6833V11.6833C9.34998 11.2 9.74173 10.8083 10.225 10.8083ZM13.3467 10.8083C13.8299 10.8083 14.2217 11.2 14.2217 11.6833V16.6833C14.2217 17.1665 13.8299 17.5583 13.3467 17.5583C12.8634 17.5583 12.4717 17.1665 12.4717 16.6833V11.6833C12.4717 11.2 12.8634 10.8083 13.3467 10.8083Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineTrashCan);
export default __webpack_public_path__ + "static/media/line-trash-can.668b14146fa7bdbd4c47c12b46fc0070.svg";
export { ForwardRef as ReactComponent };